import { DatePicker, Select } from "antd";
import { FormEventHandler, useEffect, useState } from "react";
import { Control, useController } from "react-hook-form";
import { IconSearch } from "../../../../shared/Icons/IconSearch";
import { useGetAllUsers } from "../../../Usuarios/hooks/useGetUsers";

interface FiltroAuditoriaType {
  tabelaDataSource: any[];
  usuariosDataSource?: any[];
  onSubmit?: FormEventHandler | undefined;
  control: Control<any>;
  onClick?: any;
}

interface UserOption {
  value: string;
  label: string
}

export function FiltroAuditoria({ tabelaDataSource, usuariosDataSource, onSubmit, control, onClick }: FiltroAuditoriaType) {
  const [userOptions, setUserOptions] = useState<UserOption[]>([]);
  const { field } = useController({control, name: "DataCriacao"})
  const { RangePicker } = DatePicker;

  const {data: usersData} = useGetAllUsers();

  useEffect(() => {
    if (usersData) {
      const options = usersData.map((user: any) => ({
        value: user.Login,
        label: user.Login,
      }));
      setUserOptions(options);
    }
  }, [usersData]);

  return (
    <form onSubmit={onSubmit} className="flex">
      <SelectFilter
        dataSource={tabelaDataSource}
        placeholder="Buscar Tabela"
        dataName="Tabela"
        control={control}
      />

      <SelectFilter
        dataSource={userOptions}
        placeholder="Buscar Usuário"
        dataName="Usuario"
        control={control}
      />

      <div className="flex items-center">
        <RangePicker className="h-[2.5rem]" {...field} />
        <button
          onClick={onClick}
          type="submit"
          className="h-10 w-[3rem] rounded-r-md focus:outline-none border-solid border-[1px] flex items-center justify-center hover:bg-gray-50">
          <IconSearch color="#858E96" />
        </button>
      </div>
    </form>
  );
}

interface SelectType {
  dataSource: any[];
  placeholder: string;
  control: Control<any>;
  dataName: string;
}

function SelectFilter({ dataSource, placeholder, control, dataName }: SelectType) {
  const { field } = useController({ control, name: dataName })

  return (
    <>
      <Select
        options={dataSource}
        {...field}
        style={{ width: 150 }}
        placeholder={placeholder}
        optionFilterProp="children"
        filterOption={(input, option) => (option?.label ?? '').includes(input)}
        filterSort={(optionA, optionB) =>
          (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
        }
        showSearch
        allowClear
      />
    </>
  );
}
